import { EmtIcon, EmtSwitch, EmtTypography } from 'emt-components-v2'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import { styled, SxProps } from '@mui/material/styles'
import { Choice, Sentence } from '@/data'

const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  display: 'block',
  textAlign: 'center',
  marginTop: '5px',
  '&.error': {
    color: theme.palette.error.main,
  },
}))

type Props = {
  title: string
  choice: Choice
  isOwner: boolean
  isRegistering: boolean
  handleChoice: (typeSlug: string, value: boolean, choiceSlug: string) => void
  selectedChoices: Record<string, boolean>
  helperText?: string
  error?: boolean
}

export const EditAvailabilities: React.FC<Props> = ({
  title,
  choice,
  isOwner,
  isRegistering,
  handleChoice,
  selectedChoices,
  helperText,
  error,
}) => {
  const formControlLabelSx: SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    marginRight: 0,
  }

  const getSentence = (sentence: Sentence): string => {
    const roleSentence = isOwner ? sentence.ownerSentence : sentence.borrowerSentence

    const finalSentence = isRegistering ? roleSentence.inscriptionSentence : roleSentence.profileSentence

    return finalSentence
  }

  return (
    <>
      <EmtTypography variant="body1" fontWeight="bold">
        {title}
      </EmtTypography>
      {choice.types.map((type) => (
        <FormControlLabel
          key={type.slug}
          control={
            <EmtSwitch
              checked={selectedChoices[type.slug] || false}
              size="medium"
              onChange={(e) => {
                handleChoice(type.slug, e.target.checked, choice.slug)
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {type.icon?.className && <EmtIcon className={type.icon?.className} />}
              <EmtTypography variant="body1" lineHeight={1} color="greyGradient.main">
                {getSentence(type.sentence)}
                <br />
                {type.subSentence && <EmtTypography variant="caption">{getSentence(type.subSentence)}</EmtTypography>}
              </EmtTypography>
            </Box>
          }
          sx={formControlLabelSx}
        />
      ))}
      {helperText && <StyledFormHelperText className={error ? 'error' : ''}>{helperText}</StyledFormHelperText>}
    </>
  )
}
